import { Color } from "@repo/app-types/constants/colors";
import { Pill, type PillColor } from "@repo/ui/Pills/pill";
import { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";

// 1-5 satisfaction scale
const scoreToDetails: Record<number, { color: PillColor; text: string }> = {
  1: { color: Color.Red, text: "Very Dissatisfied" },
  2: { color: Color.Yellow, text: "Dissatisfied" },
  3: { color: Color.Gray, text: "Neutral" },
  4: { color: Color.Lime, text: "Satisfied" },
  5: { color: Color.Green, text: "Very Satisfied" },
};

export const SentimentScore: FC<{ score: number }> = ({ score }) => {
  const scoreDetails = scoreToDetails[score];

  if (scoreDetails === undefined) return null;

  return (
    <Pill
      size={Size.SMALL}
      color={scoreDetails.color}
      label={`${score}/5: ${scoreDetails.text}`}
    />
  );
};

export function formatSentimentTickForChart(value: number) {
  const scoreDetails = scoreToDetails[value];

  if (scoreDetails === undefined) {
    throw new Error("Invalid sentiment tick value");
  }

  return scoreDetails.text;
}
